import React from "react";
import hbsLogo from "./../../assets/img/hbs/logo.JPG";
import { Urls } from "../../constants/UrlConstants";
import Content from "../../content/Content";
import SmartLink from "../../../src/components/shared/links/SmartLink";
import style from "../../assets/css/modules/shared/promo-image-card.css";

var noWrap = {
  whiteSpace: "nowrap"
};

const HbsPopup = {
  heading: "You are now leaving our website",
  headingWhenApiIsUnavailable:
    "We're sorry, we can't contact HBS at the moment",
  hbslogoSrc: hbsLogo,
  firstParagraph:
    "By clicking continue you will be leaving the AXA site and be directed to the Virtual Lucy service at HBS.",
  description: (
    <React.Fragment>
      <p>
        To save you from manually providing your personal details to HBS, we
        will securely pass them the following information:
      </p>
      <ul>
        <li>Your Membership number</li>
        <li>Your title</li>
        <li>Your name</li>
        <li>Your gender</li>
        <li>Your date of birth</li>
        <li>Your E-mail Address</li>
        <li>Your Address and postcode</li>
      </ul>
      <p>By clicking continue you are confirming you are happy to do this.</p>
      <p>
        <strong>Please note:</strong> The Virtual Lucy service cannot be used on{" "}
        <span style={noWrap}>Internet Explorer.</span>
      </p>
    </React.Fragment>
  ),
  apiUnavailableMessage:
    "We’re really sorry but there appears to be a problem with contacting HBS at the moment. Please call us on 08000 294236 and we will help you continue with your claim.",
  backlink: "cancel",
  continueButtonLabel: "continue",
  continueButtonId: "continue-button-hbs",
  tryAgainButtonLabel: "try again",
  tryAgainButtonId: "try-again-button-hbs",
  nextButtonLabel: "next",
  nextButtonId: "next-button-hbs",

  isThePatientHeader:
    "Thanks, here’s how to get started:",
  isThePatientBody: (
    <React.Fragment>
      <div>
        <ul className="hbsUpperContent">
          <li className="liHbs">We’re working with HBSUK, a specialist-led online service that is part of the AXA Group. When booking your first appointment with HBSUK, select the AXA Health login and use your AXA Health membership number, found on your membership documents.</li>
          <li className="liHbs">Fill in a few details about your symptoms, and you’ll be offered an appointment with a physiotherapist, an advanced physiotherapist, or a specialist, based on the information you give us.</li>
          <li className="liHbs">Select a video or phone appointment at a time that suits you (appointments are available Monday to Friday 8am to 8pm). They’ll talk through your symptoms, assess you and work out what could be wrong.</li>
          <li className="liHbs">They’ll then guide you to the next steps – that could be self-help exercises at home, or further treatment<sup>1</sup>.</li>
        </ul>
      </div>

      <div className="hbsClass">
        <ol type="1">
          <li className="liHbs">You'll need the appropriate benefits for any face-to-face consultations, tests or treatment and any benefit limits or contribution you normally make towards treatment costs each year will apply. We recommend you contact us before arranging any tests or face-to-face treatment so we can check your membership will cover the cost.</li>
        </ol>
      </div>
      <div class="row bookHbsBottom">
        <SmartLink
          to={Urls.HbsFaqs}
          className={style.hbsStyleLink}
          isExternalLink={true} >
          <Content name="Frequently Asked Questions" /> <span className="ml-2">➔</span>
        </SmartLink>
      </div>
    </React.Fragment>
  ),
  buttonLabel: "Book an appointment"
};

export default HbsPopup;
